import { ApplicationType } from '@wix/editor-application';
const isAddon = component => {
  return component.type === ApplicationType.EditorAddon;
};
export class AddonsExtractor {
  extract(app) {
    const appDefinitionId = app.appDefinitionId;
    if (!app.components || !appDefinitionId) {
      return [];
    }
    const addons = [];
    const components = app.components;
    for (const component of components) {
      if (!isAddon(component)) {
        continue;
      }
      const {
        editorScript,
        toolPanelConfig,
        marketData
      } = component.data || {};
      const addon = {
        appDefinitionId,
        appDefinitionName: app.appDefinitionName || 'Unknown addon',
        type: ApplicationType.EditorAddon,
        data: {
          toolPanelConfig: {
            ...(toolPanelConfig || {}),
            initialPosition: {
              x: '200',
              y: '200',
              ...(toolPanelConfig == null ? void 0 : toolPanelConfig.initialPosition)
            }
          },
          marketData
        }
      };
      if (editorScript) {
        addon.url = editorScript;
      }
      addons.push(addon);
    }
    return addons;
  }
}
//# sourceMappingURL=AddonsExtractor.js.map